var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isUserHost ? _c('confirm-dialog', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'confirm-dialog', {
    title: '참여승인',
    text_exit: '거부',
    text_next: '승인',
    exit: _vm.exit,
    next: _vm.next,
    loading: _vm.loading
  }, false), [_c('v-sheet', {
    staticClass: "page-text--lg font-weight-bold text-center"
  }, [_vm._v(" 참여를 승인하시겠습니까? ")])], 1) : _c('div', [_vm._t("activator", null, null, {
    on: {
      click: _vm.click
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }